import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
import Icon from '@/components/base/Icon/Icon.vue';
import BaseItem from '@/components/item/BaseItem/BaseItem.vue';
import { executeOneInTime } from '@/util/helper';

// client js begin
import { receive, getWelfareInfo, magicReceiveNew } from "./receiveService";
import { markRead } from '@/services/magicService';
// client js end

var _ActLabel = {
  ActLabel_New: 1,
  ActLabel_Hot: 2
};

// eslint-disable-next-line
var E_GetStatus = {
  E_GetStatus_UnGet: 0,
  // 进行中,未领取
  E_GetStatus_Got: 1,
  // 已领取
  E_GetStatus_SnatchOut: 2,
  // 已抢完
  E_GeStatus_OnAndBook: 3,
  // 还没开始,可以预约
  E_GeStatus_OnAndHasBook: 4,
  // 还没开始，已经预约
  E_GeStatus_ActEnd: 5 // 活动已经结束
};

export default {
  props: {
    modId: {
      required: true,
      type: String
    },
    channelId: {
      required: true,
      type: String
    },
    item: {
      required: true,
      type: Object
    },
    showVipIcon: {
      type: Boolean,
      default: false
    },
    ip: {
      type: String
    },
    platform: {
      type: Number
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      popData: {
        useInfo: '<p>使用条件：参与VIP专属好课活动，立减10元</p>↵↵<p>使用期限：2018-01-22至2018-12-22</p>'
      },
      isUseInfoVisible: false
    };
  },
  computed: {
    ActLabel: function ActLabel() {
      return _ActLabel;
    },
    isH5Type: function isH5Type() {
      return this.item.tActType.sActType === 'm_h5' || this.item.tActType.sActType === 'h5';
    },
    isGot: function isGot() {
      return this.item.tActState.iUserGetStatus === E_GetStatus.E_GetStatus_Got;
    },
    isSnatchOut: function isSnatchOut() {
      return this.item.tActState.iUserGetStatus === E_GetStatus.E_GetStatus_SnatchOut;
    },
    isEnd: function isEnd() {
      return this.item.tActState.iUserGetStatus === E_GetStatus.E_GeStatus_ActEnd;
    },
    isHot: function isHot() {
      return this.item.tActState.iActLabel === _ActLabel.ActLabel_Hot;
    },
    h5Url: function h5Url() {
      return this.item.tActType.sH5Url || '//film.qq.com/weixin/v3/asset/index.html?header=0&ptag=welfare&tab=award';
    },
    // 海报数据上报参数
    posterParams: function posterParams() {
      var _this$item = this.item,
        title = _this$item.sTitle,
        cubeId = _this$item.sActID;
      return {
        f_module: '专属福利',
        f_resource: "".concat(title).concat(this.isH5Type ? '查看' : '领取'),
        f_type: 4,
        f_cubeid: cubeId,
        eid: 'poster',
        item_idx: this.index,
        content_id: title,
        rtype: 'h5',
        poster_type: 'up_pic_down_text_vertical'
      };
    }
  },
  methods: {
    click: function () {
      var _click = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var judge, _this$item$mpExpansio, mpExpansion;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.checkVipStatus();
              case 2:
                judge = _context.sent;
                if (judge) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return");
              case 5:
                if (this.isH5Type) {
                  this.openUrl(this.item.tActType.sH5Url);
                  if (!this.isGot) {
                    markRead(this.item.sActID);
                    this.item.tActState.iUserGetStatus = E_GetStatus.E_GetStatus_Got;
                  }
                } else {
                  //        this.showUseInfo()
                  //        return
                  _this$item$mpExpansio = this.item.mpExpansion, mpExpansion = _this$item$mpExpansio === void 0 ? {} : _this$item$mpExpansio;
                  if (this.isGot) {
                    // this.showUseInfo()
                    this.openUrl(this.h5Url);
                  } else if (mpExpansion.actID && mpExpansion.modID) {
                    this.receiveNew();
                  } else {
                    this.receive();
                  }
                }
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function click(_x) {
        return _click.apply(this, arguments);
      }
      return click;
    }(),
    receive: executeOneInTime( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return receive(this.item.sActID, this.item.sActKey, this.modId, this.channelId, this.ip, this.platform);
            case 3:
              data = _context2.sent;
              this.setPopData(data);
              this.isUseInfoVisible = true;
              this.item.tActState.iUserGetStatus = E_GetStatus.E_GetStatus_Got;
              _context2.next = 13;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              this.toast(_context2.t0.msg);
              // 已领取
              if (_context2.t0.code === -50001009) {
                this.item.tActState.iUserGetStatus = E_GetStatus.E_GetStatus_Got;
              }
            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 9]]);
    }))),
    receiveNew: executeOneInTime( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _ref3, _ref3$actID, actId, _ref3$modID, modId, desc, _data$receive_list, _data$receive_list$, data, _data$receive_list$0$, receiveName, receiveH5, receiveImgUrl, popData;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3 = this.item.mpExpansion || {}, _ref3$actID = _ref3.actID, actId = _ref3$actID === void 0 ? '' : _ref3$actID, _ref3$modID = _ref3.modID, modId = _ref3$modID === void 0 ? '' : _ref3$modID, desc = _ref3.desc_2;
              if (!(!actId || !modId)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.prev = 3;
              _context3.next = 6;
              return magicReceiveNew(actId, modId);
            case 6:
              data = _context3.sent;
              this.item.tActState.iUserGetStatus = E_GetStatus.E_GetStatus_Got;
              this.isUseInfoVisible = true;
              _data$receive_list$0$ = (_data$receive_list = data.receive_list) === null || _data$receive_list === void 0 ? void 0 : (_data$receive_list$ = _data$receive_list[0]) === null || _data$receive_list$ === void 0 ? void 0 : _data$receive_list$.receive_name, receiveName = _data$receive_list$0$.receive_name, receiveH5 = _data$receive_list$0$.receive_url_h5, receiveImgUrl = _data$receive_list$0$.receive_url;
              popData = {
                useInfo: desc,
                desc_2: desc,
                name: receiveName || this.item.sTitle,
                pic: receiveImgUrl || this.item.tPicList.mpList.pic_600x336,
                jump_url_h5: receiveH5
              };
              this.setPopData(popData);
              _context3.next = 19;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](3);
              this.toast(_context3.t0.msg);
              console.log('领取报错', _context3.t0);
              if (_context3.t0.code === -903) {
                this.item.tActState.iUserGetStatus = E_GetStatus.E_GetStatus_Got;
              }
            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[3, 14]]);
    }))),
    setPopData: function setPopData(data) {
      var isFetched = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.popData = {
        pic: this.item.tPicList.mpList.pic_600x336,
        useInfo: data.desc_2,
        jumpUrl: this.h5Url,
        name: data.name,
        isFetched: isFetched
      };
    },
    showUseInfo: function () {
      var _showUseInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getWelfareInfo(this.item.sActID);
              case 2:
                data = _context4.sent;
                this.setPopData(data, true);
                this.isUseInfoVisible = true;
              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function showUseInfo() {
        return _showUseInfo.apply(this, arguments);
      }
      return showUseInfo;
    }()
  },
  components: {
    Icon: Icon,
    BaseItem: BaseItem,
    WelfarePop: function WelfarePop() {
      return import("./WelfarePop/WelfarePop.vue");
    }
  },
  reportData: {
    '专属福利查看': function 专属福利查看(p) {
      return p;
    },
    '专属福利领取': function 专属福利领取(p) {
      return p;
    }
  }
};